export default {
  props: ['list']
};